import React from "react";
import { IMenuItem } from "./MenuItem.interface";
import StyledMenuItem from "./MenuItem.styled";

const MenuItem = ({ label, Icon, ...props }: IMenuItem) => (
  <StyledMenuItem {...props} exact>
    {Icon && <Icon width={24} />}
    {label}
  </StyledMenuItem>
);

export default MenuItem;
